import React, { FC, useMemo } from "react";
import { Input } from "antd";
import { throttle } from "throttle-debounce";
import { MatterModalTemplateSearch } from "../../../data-types";

import styles from "./template-title-search.module.css";

const { ["search-filter"]: searchFilterClassName } = styles;

type Props = {
  templateSearch: MatterModalTemplateSearch;
  debounceTimeout?: number;
  placeholder?: string;
};

export const TemplateTitleSearch: FC<Props> = ({
  templateSearch,
  debounceTimeout = 800,
  placeholder,
}) => {
  const { onChange: updateTemplateSearchValue } = templateSearch;

  const onSearch = useMemo(() => {
    const loadOptions = (value: string) => {
      updateTemplateSearchValue && updateTemplateSearchValue(value);
    };

    return throttle(debounceTimeout, loadOptions);
  }, [debounceTimeout]);

  return (
    <Input
      onChange={(e) => {
        const v = e.target.value;
        onSearch(v);
      }}
      placeholder={placeholder}
      className={searchFilterClassName}
    />
  );
};
